<div
  *ngIf="enableEnhancedProductSelection; else legacyLayout"
  [ngClass]="{ 'bl-validation-error': !loanGroup && (pageSubmitted$ | async) }"
>
  <!-- Loan group selection UI -->
  <ng-template #loanGroupView>
    <ul class="bl-display--flex bl-flex-flow--wrap">
      <ng-container
        *ngFor="
          let item of consumerLoanGroups | slice : 0 : (allProductsVisible ? undefined : maxInitialProducts);
          let i = index;
          let even = even
        "
      >
        <li class="loan-select-container bl-margin-bottom--16" [class.bl-margin-left--0]="even">
          <button
            [id]="'arcdx-product-' + i"
            (click)="onChangeLoanGroup(item.loanGroup)"
            class="loan-group-button bl-display--flex bl-align-items--center"
            [class.selected]="item.loanGroup === loanGroup"
          >
            <!-- questions on this? see comments in dx-product-image component -->
            <dx-product-image
              size="56px"
              [icon]="item.groupIcon"
              [product]="item?.loanGroup"
              flowType="ola"
              class="bl-display--flex"
            ></dx-product-image>
            <span class="bl-display--block bl-margin-left--16 bl-font-weight--800 bl-font-color--black bl-text-align--left">
              {{ item.displayName }}
            </span>
          </button>
        </li>
      </ng-container>
    </ul>
    <button
      *ngIf="consumerLoanGroups.length > maxInitialProducts"
      (click)="allProductsVisible = !allProductsVisible"
      class="bl-font-color--primary bl-font-weight--800 bl-display--block bl-padding-y--16 bl-margin-x--auto"
    >
      {{ toggleAllProductsText }}
    </button>
    <span role="alert">
      @if (!loanGroup && (pageSubmitted$ | async)) {
      <span id="loan-type-error" class="bl-error-msg bl-margin-right--16" aria-label="alert">
        {{ 'LoanSelection/selectLoanTypeError' | dictionary }}
      </span>
      }</span
    >
  </ng-template>
  <!-- Loan product UI -->
  <!-- Added the conditional check to show the Loan product selection only if there're more than 1 Products -->
  <ng-container *ngIf="loanGroup && isLoanGroupHasProduct && selectedConsumerLoanGroup?.loanProducts.length > 1; else loanGroupView">
    <div class="bl-form-field-wrap bl-margin-bottom--16" [ngClass]="{ 'bl-validation-error': !loanType && (pageSubmitted$ | async) }">
      <legend aria-details="" class="bl-font-size--14 bl-font-weight--800 bl-margin-bottom--4 bl-required">
        Which type of {{ selectedConsumerLoanGroup.displayName }} are you applying for?
      </legend>
      <ul class="bl-margin-bottom--16">
        <li
          class="radio-wrap bl-check-wrap bl-margin-top--4 bl-margin-bottom--8"
          *ngFor="let loanProduct of selectedConsumerLoanGroup.loanProducts; let i = index"
          [hidden]="loanProduct.isHideLoanProductSelection"
        >
          <input
            type="radio"
            [id]="'arcdx-loan-product-' + i"
            [value]="loanProduct.productName"
            name="loan-type"
            [(ngModel)]="loanType"
            (change)="onChangeLoantype(loanProduct)"
          />
          <label class="bl-label" [for]="'arcdx-loan-product-' + i">
            <!-- questions on this? see comments in dx-product-image component -->
            <dx-product-image
              size="32px"
              [icon]="selectedConsumerLoanGroup?.groupIcon"
              [product]="selectedConsumerLoanGroup?.loanGroup"
              flowType="OLA"
              class="bl-display--flex"
            ></dx-product-image>
            <span class="bl-margin-left--16">{{ loanProduct.displayName }}</span>
          </label>
        </li>
        <span *ngIf="!loanType && (pageSubmitted$ | async)" class="bl-error-msg bl-margin-right--16">
          <span role="alert">
            {{ 'LoanSelection/selectLoanProductError' | dictionary }}
          </span>
        </span>
      </ul>
    </div>
    <div *ngIf="loanProductDescription" [innerHTML]="loanProductDescription | safe : 'html'"></div>
    <button (click)="clearLoanGroupandLoanType()" class="button-anchor bl-margin-top--32 bl-margin-bottom--16">
      {{ 'LoanSelection/changeLoanType' | dictionary }}
    </button>
  </ng-container>
</div>

<!-- TODO: text should be coming from workflow json or dictionary flvor.json, not hardcoded -->
<ng-template #legacyLayout>
  <div class="bl-margin-bottom--16">
    <label class="bl-label bl-font-weight--800 bl-font-size--14 bl-required" for="ola-loan-type-building-block">
      What loan are you applying for?
    </label>
    <div class="bl-select-wrap" [ngClass]="{ 'bl-validation-error': !loanGroup && (pageSubmitted$ | async) }">
      <select class="bl-select bl-input" id="ola-loan-type-building-block" [(ngModel)]="loanGroup" (change)="onChangeLoanGroup(loanGroup)">
        <option value="" disabled>Select One</option>
        <option *ngFor="let item of consumerLoanGroups" [value]="item.loanGroup">{{ item.displayName }}</option>
      </select>
      <span *ngIf="!loanGroup && (pageSubmitted$ | async)" id="loan-type-error" class="bl-error-msg bl-margin-right--16" role="alert">{{
        'LoanSelection/required' | dictionary
      }}</span>
      <span *ngIf="!loanGroup && (pageSubmitted$ | async)" class="bl-screen-reader-only" role="alert">
        {{ 'LoanSelection/loanTypeRequired' | dictionary }}</span
      >
    </div>
  </div>
  <!-- Added the conditional check to show the Loan product selection only if there're more than 1 Products -->
  <fieldset
    *ngIf="loanGroup && selectedConsumerLoanGroup?.loanProducts.length > 1"
    class="bl-margin-bottom--16"
    [ngClass]="{ 'bl-validation-error': !loanType && (pageSubmitted$ | async) }"
  >
    <legend aria-details="" class="bl-font-size--14 bl-font-weight--800 bl-margin-bottom--4 bl-required" *ngIf="isLoanGroupHasProduct">
      Which type of {{ selectedConsumerLoanGroup.displayName }} are you applying for?
    </legend>
    <div *ngIf="selectedConsumerLoanGroup.isLoanGroupHasProduct" class="bl-margin-bottom--16">
      <div
        class="bl-check-wrap bl-margin-top--4 bl-margin-bottom--8"
        *ngFor="let loanProduct of selectedConsumerLoanGroup.loanProducts"
        [hidden]="loanProduct.isHideLoanProductSelection"
      >
        <input
          type="radio"
          id="ola-consumer-loan-type-option-{{ loanProduct.productName }}"
          [value]="loanProduct.productName"
          name="loan-type"
          [(ngModel)]="loanType"
          (change)="onChangeLoantype(loanProduct)"
        />
        <label class="bl-label" for="ola-consumer-loan-type-option-{{ loanProduct.productName }}">{{ loanProduct.displayName }}</label>
      </div>
      <span *ngIf="!loanType && (pageSubmitted$ | async)" class="bl-error-msg bl-margin-right--16">
        <span>{{ 'LoanSelection/required' | dictionary }}</span>
        <span role="alert" class="bl-screen-reader-only">
          {{ 'LoanSelection/loanTypeRequired' | dictionary }}
        </span>
      </span>
    </div>
  </fieldset>
  <div *ngIf="!!loanProductDescription" [innerHTML]="loanProductDescription | safe : 'html'"></div>
</ng-template>
